import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import Api from "../../../lib/componentApi";
import validateForm from "../../../lib/validateForm";
import getAppErrors from "../../../lib/appErrors";

import JoinUsForm from "../../../components/Auth/JoinUsForm";
import AppErrors from "../../../components/Common/AppErrors";

class JoinUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      restaurantName: "",
      restaurantAddress: "",
      contactName: "",
      businessName: "",
      position: "",
      contactNumber: "",
      email: "",
      avgWeeklyOrders: "",
      errorMessage: null,
      formErrors: {
        restaurantName: "",
        restaurantAddress: "",
        contactName: "",
        businessName: "",
        position: "",
        contactNumber: "",
        email: "",
        avgWeeklyOrders: ""
      },
      active: false
    };
  }
  onChange = event => {
    event.preventDefault();
    const input = event.target.id;
    this.setState(
      {
        [input]: event.target.value
      },
      () => {
        const currentState = { [input]: this.state[input] };
        const inputError = validateForm(currentState, "joinUs");
        const { formErrors } = this.state;
        formErrors[input] = inputError;
        this.setState({ formErrors }, () => {
          const {
            restaurantName,
            restaurantAddress,
            contactName,
            contactNumber,
            email,
            businessName,
            position,
            avgWeeklyOrders
          } = this.state;
          const errors = Object.values(this.state.formErrors).filter(Boolean);
          if (
            email &&
            restaurantName &&
            businessName &&
            restaurantAddress &&
            position &&
            contactName &&
            contactNumber &&
            avgWeeklyOrders &&
            !errors.length
          ) {
            this.setState({ active: true });
          } else {
            this.setState({ active: false });
          }
        });
      }
    );
  };
  handleClose = () => {
    window.location.href = "/";
  };
  handleSubmit = event => {
    event.preventDefault();
    const { onClose } = this.props || this.handleClose;
    const {
      restaurantAddress,
      position,
      businessName,
      restaurantName,
      contactName,
      contactNumber,
      email,
      avgWeeklyOrders
    } = this.state;
    Api.post(
      "/api/join-us",
      {
        restaurantName,
        restaurantAddress,
        position,
        businessName,
        contactName,
        contactNumber,
        email,
        avgWeeklyOrders: parseInt(avgWeeklyOrders)
      },
      (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          const errorMessage = getAppErrors(response.code);
          this.setState({
            errorMessage:
              (errorMessage && errorMessage.message) || response.message
          });
        } else {
          if (response.status) {
            onClose({ status: "info" });
          } else {
            onClose({ status: null });
          }
        }
      }
    );
  };
  render() {
    const {
      restaurantName,
      restaurantAddress,
      position,
      businessName,
      contactName,
      contactNumber,
      email,
      avgWeeklyOrders,
      errorMessage,
      formErrors,
      active
    } = this.state;
    const { onClose } = this.props;
    return (
      (errorMessage && (
        <AppErrors
          message={errorMessage}
          onClickClose={() =>
            this.setState({
              errorMessage: null
            })
          }
        />
      )) || (
        <JoinUsForm
          restaurantName={restaurantName}
          restaurantAddress={restaurantAddress}
          position={position}
          businessName={businessName}
          contactName={contactName}
          contactNumber={contactNumber}
          email={email}
          avgWeeklyOrders={avgWeeklyOrders}
          onChange={this.onChange}
          onClose={onClose}
          handleSubmit={this.handleSubmit}
          formErrors={formErrors}
          active={active}
        />
      )
    );
  }
}

export default withRouter(JoinUs);
